<div class="credit-cards__aopa">
  <ul class="ul ul--lg ul--circle ul--two-col">
    <li *ngIf="hasTag(this.tags, 'Credit Cards::Mastercard')">
      AOPA Mastercard <a href="https://www.aopa.org/membership/aopa-credit-cards?utm_campaign=airports&utm_medium=web&utm_source=airports&utm_content=learnmore" target="_blank"><u>(Learn More)</u></a>
    </li>
    <li *ngFor="let creditCard of nonAOPAMasterCardCreditCards">{{ creditCard }}</li>
  </ul>
</div>
